<template>
<div>
    <div v-if="isMutation" class="form-row">
        <div class="col-7">
            <span>Effective On: </span>
            <span>{{ $filters.date(deferredComp.effective_on) }}</span>
        </div>

        <div class="col-5 text-right">
            <a v-if="mode == 'full'" href @click.prevent="mode = 'diff'">Show Changes</a>
            <a v-if="mode == 'diff'" href @click.prevent="mode = 'full'">Show Full Plan Info</a>
        </div>
    </div>

    <div v-else>
        <span>Last Modified Date: </span>
        <span>{{ $filters.date(deferredComp.updated_on) }}</span>
    </div>

    <div v-if="mode == 'diff'" class="mt-2">
        <h5>Changes</h5>

        <div v-if="diff.contribution_method">
            <span>Contribution Method: </span>
            <span>{{ methodLabel(diff.contribution_method.old) }} -&gt; {{ methodLabel(diff.contribution_method.cur) }}</span>
        </div>

        <div v-if="diff.employee_contribution_pct">
            <span>Employee Contribution: </span>
            <span>{{ diff.employee_contribution_pct.old }}% -&gt; {{ diff.employee_contribution_pct.cur }}%</span>
        </div>

        <div v-if="diff.employee_contribution_amount">
            <span>Employee Contribution: </span>
            <span>${{ diff.employee_contribution_amount.old }} -&gt; ${{ diff.employee_contribution_amount.cur }}</span>
        </div>

        <div v-if="diff.is_hpi">
            <span>Highly Paid Individual: </span>
            <span>{{ yesNo(diff.is_hpi.old) }} -&gt; {{ yesNo(diff.is_hpi.cur) }}</span>
        </div>
    </div>

    <div v-if="mode == 'full'" class="mt-2">
        <h5>Plan Info</h5>

        <div>
            <span>Employee Contribution: </span> <span>{{ contribution }}</span><br />
        </div>

        <div v-if="deferredComp.is_hpi">
            <span>Highly Paid Individual: </span> <span>Yes</span><br />
        </div>
    </div>

</div>
</template>

<script>

export default {
    props: ['isMutation', 'deferredComp', 'diff', 'deferredCompPlanLookup'],
    computed: {
        contribution() {
            if (this.deferredComp.contribution_method == 'amount') {
                return '$' + this.deferredComp.employee_contribution_amount
            }

            return this.deferredComp.employee_contribution_pct + '%'
        },
    },
    data() {
        return {
            mode: this.isMutation ? 'diff' : 'full',  // Can be diff or full
        }
    },
    methods: {
        methodLabel(value) {
            return value == 'amount' ? 'Flat dollar amount' : 'Percentage of pay'
        },
        yesNo(value) {
            return value ? 'Yes' : 'No'
        },
    },
}
</script>
